import { snapchatDashboardApi } from '../api/snapchatDashboard';
import { fmtInt, fmtNum, fmtPct } from './AppLikeDeliveryDashboard';
import { rtbDimensionsForGrain, VooglamPerformanceDashboard, type DashboardFilter, type MetricField, type TrendMetric, type VooglamDashboardConfig } from './RtbDeliveryDashboard';

const SNAP_EFFICIENCY_METRICS: MetricField[] = [
  { key: 'spend', label: '账户花费', fmt: fmtNum, permKey: 'spend' },
  { key: 'cpm', label: 'CPM', fmt: fmtNum, permKey: 'spend' },
  { key: 'ctr', label: 'CTR', fmt: fmtPct },
  { key: 'cpc', label: 'CPC', fmt: fmtNum, permKey: 'cpc' },
  { key: 'cost_per_add_to_cart', label: '单次加购费用', fmt: fmtNum, permKey: 'cpa' },
  { key: 'cpa', label: 'CPA', fmt: fmtNum, permKey: 'cpa' },
  { key: 'aov', label: '单均价', fmt: fmtNum, permKey: 'revenue' },
  { key: 'account_roi', label: '账户ROI', fmt: fmtNum, permKey: 'roas' },
  { key: 'click_purchase_rate', label: '点击购买率', fmt: fmtPct },
  { key: 'click_add_to_cart_rate', label: '点击加购率', fmt: fmtPct },
  { key: 'purchase_conversion_rate', label: '购物车转化率', fmt: fmtPct },
  { key: 'impressions', label: '展示次数', fmt: fmtInt },
  { key: 'clicks', label: '点击次数', fmt: fmtInt },
  { key: 'add_to_cart_count', label: '加购次数', fmt: fmtInt },
  { key: 'purchases', label: '购物次数', fmt: fmtInt },
  { key: 'revenue', label: '购物转化价值', fmt: fmtNum, permKey: 'revenue' },
];

const SNAP_TREND_METRICS: TrendMetric[] = [
  { key: 'spend', label: '账户花费', fmt: fmtNum, permKey: 'spend', colorToken: '--primary', defaultSelected: true },
  { key: 'cpa', label: 'CPA', fmt: fmtNum, permKey: 'cpa', colorToken: '--green', defaultSelected: true },
  { key: 'cpc', label: 'CPC', fmt: fmtNum, permKey: 'cpc', colorToken: '--text3' },
  { key: 'cpm', label: 'CPM', fmt: fmtNum, permKey: 'spend', colorToken: '--cyan' },
  { key: 'click_purchase_rate', label: '点击购买率', fmt: fmtPct, colorToken: '--cyan', defaultSelected: true },
  { key: 'account_roi', label: '账户ROI', fmt: fmtNum, permKey: 'roas', colorToken: '--primary' },
  { key: 'click_add_to_cart_rate', label: '点击加购率', fmt: fmtPct, colorToken: '--green' },
  { key: 'purchase_conversion_rate', label: '购物车转化率', fmt: fmtPct, colorToken: '--text3' },
];

const SNAP_EFFICIENCY_FILTERS: DashboardFilter[] = [
  { key: 'country', label: '国家/地区', visibleForGrain: grain => grain !== 'day' },
];

const VOOGLAM_SNAP_CONFIG: VooglamDashboardConfig = {
  platformLabel: 'Snap',
  reportKey: 'ad_dashboard_snapchat_v_overview',
  storageKey: 'vooglam_snap_dashboard_hidden_cols',
  getTrend: snapchatDashboardApi.getVooglamTrend,
  getEfficiency: snapchatDashboardApi.getVooglamOverview,
  efficiencyMetrics: SNAP_EFFICIENCY_METRICS,
  trendMetrics: SNAP_TREND_METRICS,
  dimensionsForGrain: rtbDimensionsForGrain,
  efficiencyFilters: SNAP_EFFICIENCY_FILTERS,
  labelDataset: 'vooglam_snapchat_delivery',
};

export default function VooglamSnapchatDeliveryDashboard() {
  return <VooglamPerformanceDashboard config={VOOGLAM_SNAP_CONFIG} />;
}
